export default __webpack_public_path__ + "assets/images/5.ac2fef.png";